export default {
  tableWrapper: {
    marginBottom: '30px',
    '& table th:first-child': {
      paddingLeft: '45px',
    },
    '& table th:last-child': {
      paddingRight: '45px',
      textAlign: 'right',
    },
    '& table td:last-child': {
      paddingRight: '45px',
      '& div': {
        float: 'right',
        width: '55px',
      },
    },
    '& table td:first-child': {
      paddingLeft: '45px',
    },
    '& > section + section': {
      marginTop: 50,
    },
  },
  titleSection: {
    margin: '33px 5px 0 0',
    overflow: 'hidden',
    padding: '0 35px 0 40px',
    '& .title': {
      float: 'left',
      marginBottom: '30px',
    },

    '& .add-new-time': {
      float: 'right',
      paddingBottom: '20px',
    },
  },
  goToAmbassadorsButton: {
    margin: '0 0 0 40px',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/OnboardingTimes/styles.js